import React from 'react'
import cx from 'classnames'
import { clone } from 'lodash'
import PropTypes from 'prop-types'

import { AngleDownIcon } from '@wf-sl/common-icons'
import T3Constants from '../constants'

import styles from './select.module.css'

const propTypes = {
    disabled: PropTypes.bool,
    headerClassName: PropTypes.string,
    onClick: PropTypes.func,
    optionListPlacement: PropTypes.oneOf(['top', 'bottom']),
    options: PropTypes.array,
    placeholder: PropTypes.string,
    selectedOptions: PropTypes.array
}

const defaultProps = {
    disabled: false,
    options: [],
    selectedOptions: []
}

function SelectHeader(props) {
    const { disabled, headerClassName, onClick, optionListPlacement, options, placeholder, selectedOptions } = props
    const classNameMerged = cx(styles['select-header'], {
        [styles['disabled']]: disabled
    })
    const buttonClassName = cx(styles['select-header-button'], {
        [styles['angle-up']]: optionListPlacement === 'top'
    })
    const selection = clone(selectedOptions)
    const option = selectedOptions.shift() || options.shift()

    const affix =
        option && option.props && option.props.affix ? (
            <div className={styles['affix']}>{` ${T3Constants.HtmlEntities.NDASH} ${option.props.affix}`}</div>
        ) : (
            ''
        )

    const placeholderstring =
        placeholder && !selection.length ? (
            <span>{placeholder}</span>
        ) : (
            <span>
                {option && option.props && option.props.children}
                {affix}
            </span>
        )

    return (
        <div className={classNameMerged} onClick={onClick}>
            <div className={cx('t3-select-header-content', styles['select-header-content'], headerClassName)}>
                {placeholderstring}
            </div>
            <AngleDownIcon className={buttonClassName} />
        </div>
    )
}

SelectHeader.propTypes = propTypes
SelectHeader.defaultProps = defaultProps

export default SelectHeader
